import React from 'react';
import { AppStateProps } from '../types/types';

const AppContext = React.createContext<AppStateProps>({
  driverDetails: {},
  dispatch: () => {},
});

export default AppContext;
